import { CONF_API_URL } from 'utils/config';
import { useApiMutation } from './useApiMutation';
import { ITokenResponse } from 'utils/models';

//login Clinic API
export const useLogin = () =>
  useApiMutation<ITokenResponse, { email: string; password: string }>(
    `${CONF_API_URL}api/hazel/doctors/login`,
    'POST'
  );
//signup Clinig API
export const useSignup = () =>
    useApiMutation<
    ITokenResponse,
    { email: string; password: string; firstName: string; lastName: string }
  >(`${CONF_API_URL}api/hazel/doctors/signup`, 'POST');
